// context/FechaContext.js
import { createContext, useContext, useState } from 'react';

const FechaContext = createContext();

export const FechaProvider = ({ children }) => {
  const today = new Date().toISOString().split("T")[0];
  const [desdeButano, setDesdeButano] = useState(today);
  const [hastaButano, setHastaButano] = useState(today);
  const [desdePropano, setDesdePropano] = useState(today);
  const [hastaPropano, setHastaPropano] = useState(today);

  return (
    <FechaContext.Provider value={{ desdeButano, setDesdeButano, hastaButano, setHastaButano, desdePropano, setDesdePropano, hastaPropano, setHastaPropano }}>
      {children}
    </FechaContext.Provider>
  );
};

export const useFechas = () => useContext(FechaContext);
